import { h, createContext } from "preact";
import { useState, useEffect } from "preact/hooks";

const CountdownForm = ({ onClose, countdownTime }) => {
  const [timeLeft, setTimeLeft] = useState(countdownTime); // Начальное время в секундах
  const [isCounting, setIsCounting] = useState(true);

  useEffect(() => {
    let interval;

    if (isCounting && timeLeft > 0) {
      interval = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);
    }
    if (timeLeft == 0) {
      if(window.ajaxIndicatior) window.ajaxIndicatior.show();
      window.location = '/logout';
    }

    return () => clearInterval(interval);
  }, [timeLeft, isCounting]);

  const handleClose = () => {
    setIsCounting(false);
    onClose();
  };

  return (
    <div id="inactive-overlay-modal">
      <div class="inactive-overlay-bg"></div>
      <div class="inactive-modal-window">
        <div class="inactive-modal-title">На странице отсутствует активность</div>
        <div class="inactive-modal-desc">Личный кабинет автоматически закроется через <span id="inactive-timer-2">{timeLeft}</span> секунд</div>
        <div class="inactive-modal-question">Вы все еще тут?</div>
        <button type="button" id="inactive-modal-yes" class="inactive-modal-btn" onClick={handleClose}>Да</button>
      </div>
    </div>
  );
};

export default CountdownForm;
